import moment from "moment";
import dateFormats from "../../../../app/data/common/dateFormats";

/** Align BOL / API time strings with Create Pickup AM/PM display */
export const convertToAmPm = (time?: string | null): string => {
  if (!time) return "";
  const lowerTime = time.toLowerCase().trim();
  if (lowerTime.includes("am") || lowerTime.includes("pm")) {
    return lowerTime;
  }
  const [hourStr, minute = "00"] = time.split(":");
  let hour = parseInt(hourStr, 10);
  if (isNaN(hour)) return time;
  const ampm = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${ampm}`;
};

export const bolDateToUiFormat = (date?: string | null): string => {
  if (!date?.trim()) return "";
  const trimmed = date.trim();
  const parsed = moment(
    trimmed,
    [dateFormats.apiDate, dateFormats.uiDate, moment.ISO_8601],
    true
  );
  return parsed.isValid() ? parsed.format(dateFormats.uiDate) : trimmed;
};

export const bolDateToApiFormat = (date?: string | null): string => {
  if (!date?.trim()) return "";
  const trimmed = date.trim();
  const parsed = moment(
    trimmed,
    [dateFormats.uiDate, dateFormats.apiDate, "MM/DD/YYYY", "M/D/YYYY", moment.ISO_8601],
    true
  );
  if (parsed.isValid()) return parsed.format(dateFormats.apiDate);
  try {
    return trimmed.toApiDateFormat();
  } catch {
    const loose = moment(trimmed);
    return loose.isValid() ? loose.format(dateFormats.apiDate) : "";
  }
};

export const safeBolDate = (date?: string | null): string => bolDateToUiFormat(date);

export const safeBolTime = (time?: string | null): string => {
  if (!time?.trim()) return "";
  try {
    return time.toUiTimeFormat?.() || convertToAmPm(time) || time;
  } catch {
    return convertToAmPm(time) || time;
  }
};
